import { render, staticRenderFns } from "./OrderConfirmDialog.vue?vue&type=template&id=6019816e&"
import script from "./OrderConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmDialog.vue?vue&type=style&index=0&id=6019816e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports